export const tipList = [
  '<span class="info">同名装备</span>可在<span class="grow">铁匠铺</span>进行升星装备',
  '<span class="info">强化</span><span class="grow">+8</span>及以下时，可免费进行<span class="info">继承</span>',
  '<span class="info">绑定邮箱</span>可获得<span class="diamond">300 钻石</span>奖励',
  '<span class="unique">独特</span>装备可在<span class="grow">研究所</span>转换为<span class="info">同套装内</span>的装备',
  '游戏本体内所有<span class="info">战斗</span>均支持<span class="grow">离线进行</span>',
  '对珍贵的装备进行<span class="grow">加锁</span>可降低误操作的风险',
  '积极反馈BUG，可获得<span class="diamond">钻石奖励</span>',
  '在隐私设置中<span class="grow">允许查看穿戴装备</span>，可额外获得<span class="grow">10%</span>共斗<span class="gold">金币</span>加成',
  '在<span class="info">研究所</span>中，可将多余的装备合成为<span class="grow">指定装备</span>',
  '通过<span class="antiquity">不朽之塔</span> 30层后，可在<span class="awaken">觉醒殿堂</span>进行觉醒',
]
